module.exports = __webpack_public_path__ + "static/media/about-new.fb9a8e58.jpg";